// @flow

import { onlyWhenSupport , type UserInputValidationError, type UserInputValidatorArgs, VALID} from '@tectonics/prs/validation';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { validateCostaRicanDocument } from '@tectonics/prs/costa-rica/validation/costa-rican-document';
import { validateCostaRicanPhoneNumber } from '@tectonics/prs/costa-rica/validation/costa-rican-phone-number';
import { getCurrentPaymentMethodOptionalFields, hasOptionalField } from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  let optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];

  switch (userInputName) {
    case 'costaRicanDocument':
      if (!hasOptionalField(optionalFields, 'document')) {
        return onlyWhen('field_costa_rican_document') && validateCostaRicanDocument(userInputValue);
      }
      return null;

    case 'costaRicanPhoneNumber':
      if (!hasOptionalField(optionalFields, 'telephone')) {
        return onlyWhen('field_costa_rican_phone_number') && validateCostaRicanPhoneNumber(userInputValue);
      }
      return null;

    default:
      return VALID;
  }
}
